import { atom, useAtom } from 'jotai';
import * as React from 'react';
import { useTranslation } from 'next-i18next';
import copy from 'copy-to-clipboard';
import { RWebShare } from 'react-web-share';
import { LinkIcon } from '@heroicons/react/24/outline';

import { Alert, Button, showToast, Modal, ModalContent } from '@restworld/ui-ds-base';
import { CUSTOM_EMPLOYER_BASE_URL, useResponsiveBreakPoints } from '@restworld/utils-common';

import { referencesModalClassName } from './references-consent-modal';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IReferencesSendLinkRequestProps {}
export const referencesSendLinkRequestModalVisibleAtom = atom<boolean>(false);
export const selectedReferencesDataAtom = atom<{
  experienceId: string;
  venueName: string;
}>({
  experienceId: '',
  venueName: '',
});
const ReferencesSendLinkRequestModal: React.FunctionComponent<IReferencesSendLinkRequestProps> = (props) => {
  const { t } = useTranslation('worker-references-page');
  const [isVisible, setIsVisible] = useAtom(referencesSendLinkRequestModalVisibleAtom);
  const [selectedReferencesData, setSelectedReferencesData] = useAtom(selectedReferencesDataAtom);
  const { isDesktop } = useResponsiveBreakPoints();
  const shareButton = (
    <Button
      onClick={() => {
        if (isDesktop) {
          copy(`${CUSTOM_EMPLOYER_BASE_URL}/submit-reference/${selectedReferencesData?.experienceId}`);
          setIsVisible(false);
          showToast(t('references_send_link_request_modal.toast_message.success'), 'success', {
            autoClose: 3000,
            position: 'top-right',
          });
          return;
        }
      }}
      StartIcon={LinkIcon}
      fullwidth
      variant="secondary-restworld"
    >
      {t('references_send_link_request_modal.footer.button.primary')}
    </Button>
  );
  return (
    <Modal
      open={isVisible}
      onOpenChange={(v) =>
        !v &&
        (() => {
          setIsVisible(false);
          setSelectedReferencesData({ experienceId: '', venueName: '' });
        })()
      }
    >
      <ModalContent
        noPadding
        className={referencesModalClassName}
        title={
          <h5 className="px-4 lg:px-[40px] self-stretch text-center text-neutral-700 text-lg font-semibold">
            {t('references_send_link_request_modal.title')}
          </h5>
        }
        footer={
          <div className="px-4 lg:px-[40px] w-full border-t border-neutral-40 flex flex-col justify-start gap-4 py-4">
            {isDesktop ? (
              shareButton
            ) : (
              <RWebShare
                data={{
                  title: t('references_send_link_request_modal.footer.other.title', {
                    venueName: selectedReferencesData?.venueName,
                  }),
                  text: t('references_send_link_request_modal.footer.other.text', {
                    venueName: selectedReferencesData?.venueName,
                  }),
                  url: `${CUSTOM_EMPLOYER_BASE_URL}/submit-reference/${selectedReferencesData?.experienceId}`,
                }}
              >
                {shareButton}
              </RWebShare>
            )}
          </div>
        }
      >
        <div className="px-4 lg:px-[40px] flex flex-col gap-12 pt-10">
          <h5 className="text-center justify-start text-neutral-700 text-base font-normal">
            {t('references_send_link_request_modal.content.description_1', {
              venueName: selectedReferencesData?.venueName,
            })}
          </h5>
          <Alert variant="warning" text={t('references_send_link_request_modal.content.alert_message')} />
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ReferencesSendLinkRequestModal;
